import { Component, OnInit, AfterViewInit,Input, SimpleChanges } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";
import { bloomAdd } from '@angular/core/src/render3/di';
import { ToastrService } from 'ngx-toastr';
import { throwMatDialogContentAlreadyAttachedError } from '@angular/material';

@Component({
  selector: 'app-cqmns-server-status',
  templateUrl: './cqmns-server-status.component.html',
  styleUrls: ['./cqmns-server-status.component.css']
})
export class CqmnsServerStatusComponent implements OnInit {
  projectId: any;
  hostUrl: any;
  azureStatusDetails : any ;
  intervalX: any;
  isoDate: any;
  NowDate: any;
  fromTime: any;
  toTime: any;
  loader: boolean;
  userId: any;

  constructor(private http: HttpClient,
    private route: ActivatedRoute,
    private userService: UserService,
    private toastr: ToastrService, private authService: AuthService, ) { }

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hostUrl = this.userService.getUrl();
    this.userId = localStorage.getItem("userid");

  //  this.projectId = this.route.snapshot.params["projectId"];
  this.projectId = localStorage.getItem("projectId");
    var s = new Date();
    this.NowDate = new Date(s).toISOString().split('.')[0]+"Z";
    s.setMinutes(s.getMinutes() - 5);
    this.isoDate = new Date(s).toISOString().split('.')[0]+"Z";
      this.fromTime = this.NowDate;
      this.toTime = this.isoDate;
      this.loader = true;
      if(this.projectId){
      this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/statusdetails/" + this.projectId + '/' + this.isoDate + '/'+this.NowDate
        )
      )
      .subscribe(data => {
        this.loader = false;
        this.azureStatusDetails =data;
      });
    }
      this.intervalX = setInterval(() => {
        this.intervalCall()
}, 30000);
  }
  intervalCall(){
    var s = new Date();
    this.NowDate = new Date(s).toISOString().split('.')[0]+"Z";
    s.setMinutes(s.getMinutes() - 5);
    this.isoDate = new Date(s).toISOString().split('.')[0]+"Z";
      this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/statusdetails/" + this.projectId + '/' + this.isoDate + '/'+this.NowDate
        )
      )
      .subscribe(data => {
        this.azureStatusDetails =data;
      });

  }
  timerUnSubscribe() {
    if (this.intervalX) {
      clearInterval(this.intervalX);
    }
  }
  public ngOnDestroy(): void {
    this.timerUnSubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-monitoring/cqmns-server-status/cqmns-server-status.component.ts